import React, { useEffect, useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, Add, Assignment } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsFindBy, wsUpdateMasive } from 'services/WService';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext';
import FilterArticle from 'hooks/FilterArticle';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Periodo', accessor: 'period' },
  { Header: 'Cuota', accessor: 'quota' },
  { Header: 'Cód. Vendedor', accessor: 'SlpCode' },
  { Header: 'Nombre vendedor', accessor: 'SlpName' },
  { Header: 'Cód. Proveedor', accessor: 'CardCode' },
  { Header: 'Nombre proveedor', accessor: 'CardName' },
  { Header: 'Marca', accessor: 'logi_mark_description' },
  { Header: 'Categoría', accessor: 'logi_category_description' },
  { Header: 'Familia', accessor: 'logi_family_description' },
  { Header: 'Zona', accessor: 'base_zone_description' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function Quota(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal(); //uso de las funciones del modal
  const [notify, showNotify] = useToasty(); //notificación despues de las acciones
  const [quotas, setQuotas] = useState([]); //constante para el listado
  const [valueSearch, setValueSearch] = useState({});
  const [dataLoading, setDataLoading] = useState(false);

  //recargar Listado para usar en create y update
  async function listQuotas(valueSearch) {
    setDataLoading(true);
    let response = await wsFindBy('base/quota', valueSearch);
    setDataLoading(false);
    if (response.success) setQuotas(response.data);
  }

  const [multiple, setMultiple] = useState({});
  const changeMultiple = (e) => {
    setMultiple({
      ...multiple,
      [e.target.name]: e.target.value
    });
  };

  async function updateMasive(valueSearch, data) {
    let filters = valueSearch;
    if (
      !!filters.base_business_partner_id ||
      !!filters.logi_mark_id ||
      !!filters.base_zone_id ||
      !!filters.base_seller_id
    ) {
      setDataLoading(true);
      let response = await wsUpdateMasive('base/quota/massive-update', {
        filters,
        ...data
      });
      setDataLoading(false);
      if (response.success) {
        showNotify(response.message);
        listQuotas(valueSearch);
        setMultiple({});
      } else {
        showNotify(response.message, 'error');
      }
    } else {
      showNotify('Seleccione almenos un filtro', 'info');
    }
  }

  useEffect(() => {}, [multiple]);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={() => listQuotas(valueSearch)}
      />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.BASE_QUOTAS_STORE}
              component={
                <CardIcon color="primary">
                  <Assignment style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                color={props.themeContext.buttonColorSuccess}
                pointer="true"
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de Cuotas {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <FilterArticle
              getFilter={listQuotas}
              setValueSearch={setValueSearch}
              period
              mark
              zone
              seller
            />
            <hr />
            <AllowedGuard permission={ConstantPermissions.BASE_QUOTAS_MASSIVE_UPDATE}>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  updateMasive(valueSearch, multiple);
                }}
              >
                <GridContainer>
                  <GridItem md={3} xs={12}>
                    <FormControl fullWidth margin="normal" size="small" required>
                      <InputLabel>Acción</InputLabel>
                      <Select
                        value={multiple.type || ''}
                        inputProps={{
                          name: 'type',
                          onChange: changeMultiple
                        }}
                      >
                        <MenuItem value="increment">Aumento</MenuItem>
                        <MenuItem value="decrement">Descuento</MenuItem>
                        <MenuItem
                          value="exact"
                          onClick={() => {
                            setMultiple((multiple.variation = 'amount'));
                          }}
                        >
                          Fijar precio
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem md={3} xs={12}>
                    <FormControl
                      disabled={multiple.type == 'exact' || !multiple.type}
                      fullWidth
                      margin="normal"
                      size="small"
                      required
                    >
                      <InputLabel>Variación</InputLabel>
                      <Select
                        value={multiple.variation || ''}
                        inputProps={{
                          name: 'variation',
                          onChange: changeMultiple
                        }}
                      >
                        <MenuItem value="percentage">Porcentaje</MenuItem>
                        <MenuItem value="amount">Soles</MenuItem>
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem md={2} xs={12}>
                    <TextField
                      label="Cuota"
                      name="quota"
                      type="number"
                      value={multiple.quota || ''}
                      fullWidth
                      margin="normal"
                      size="small"
                      disabled={multiple.type == 'exact' ? false : !multiple.variation}
                      inputProps={{
                        onChange: changeMultiple,
                        min: 0,
                        step: 0.01
                      }}
                      required
                    />
                  </GridItem>
                  <GridItem md={2} xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                    <Button type="submit" color={props.themeContext.buttonColorSuccess} size="sm">
                      Aplicar
                    </Button>
                  </GridItem>
                </GridContainer>
              </form>
            </AllowedGuard>
            <ReactTable
              excelName="Cuotas"
              defaultWidth={2400}
              indexRow={[0, 1, 2, 3, 5, 11]}
              widthRow={[100, 80, 100, 130, 140, 0]}
              columns={columns}
              data={quotas.map((item, i) => {
                //mapeando listado para las acciones
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.BASE_QUOTAS_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color="info"
                          onClick={() => setOpen(item)}
                          className="like"
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                    </div>
                  ),
                  period: item.period,
                  quota: item.quota,
                  SlpCode: item.SlpCode,
                  SlpName: item.SlpName,
                  CardCode: item.CardCode,
                  CardName: item.CardName,
                  logi_mark_description: item.logi_mark_description,
                  logi_category_description: item.logi_category_description,
                  logi_family_description: item.logi_family_description,
                  base_zone_description: item.base_zone_description,
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
